import { render } from "./BaseMenuButton.vue?vue&type=template&id=3e3125bc"
import script from "./BaseMenuButton.vue?vue&type=script&lang=js"
export * from "./BaseMenuButton.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__